import React from 'react';
import LegalCompliancePanel from './LegalCompliancePanel';
import { Lock, AlertTriangle } from 'lucide-react';

const AGInfoTab = ({ selectedAG, setSelectedAG, userRole, onUpdate, token }) => {
  const isLocked = selectedAG?.legal_compliance?.parameters_locked;
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLocked) {
      alert('⚠️ Paramètres verrouillés : La convocation a été envoyée, les modifications ne sont plus possibles.');
      return;
    }
    onUpdate();
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Formulaire principal */}
      <div className="lg:col-span-2">
        {/* Alerte si verrouillé */}
        {isLocked && (
          <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-start space-x-2">
            <Lock size={18} className="text-amber-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-amber-700">
              <p className="font-medium">Paramètres verrouillés</p>
              <p>La convocation a été envoyée. Les informations de l'AG ne peuvent plus être modifiées pour garantir la conformité légale.</p>
            </div>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Immeuble</label>
            <select
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              value={selectedAG.building_id}
              onChange={(e) => setSelectedAG({ ...selectedAG, building_id: e.target.value })}
              disabled={isLocked}
            >
              <option value="">Sélectionner...</option>
              <option value="building1">36 rue Hector Berlioz, Agen</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Titre</label>
            <input
              type="text"
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              value={selectedAG.titre}
              onChange={(e) => setSelectedAG({ ...selectedAG, titre: e.target.value })}
              disabled={isLocked}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              rows={4}
              value={selectedAG.description}
              onChange={(e) => setSelectedAG({ ...selectedAG, description: e.target.value })}
              disabled={isLocked}
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
              <input
                type="date"
                className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                value={selectedAG.date?.split('T')[0]}
                onChange={(e) => setSelectedAG({ ...selectedAG, date: e.target.value })}
                disabled={isLocked}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Heure</label>
              <input
                type="time"
                className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                value={selectedAG.heure}
                onChange={(e) => setSelectedAG({ ...selectedAG, heure: e.target.value })}
                disabled={isLocked}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Lieu</label>
            <input
              type="text"
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              value={selectedAG.lieu}
              onChange={(e) => setSelectedAG({ ...selectedAG, lieu: e.target.value })}
              disabled={isLocked}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Complément</label>
            <input
              type="text"
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${isLocked ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              placeholder="Salle Haussmann"
              value={selectedAG.complement_lieu || ''}
              onChange={(e) => setSelectedAG({ ...selectedAG, complement_lieu: e.target.value })}
              disabled={isLocked}
            />
          </div>

          {userRole === 'gestionnaire' && !isLocked && (
            <button
              type="submit"
              className="bg-[#00D3A8] hover:bg-[#00C7A1] text-white py-2 px-6 rounded-lg transition-colors"
            >
              Mettre à jour
            </button>
          )}
        </form>
      </div>
      
      {/* Panneau de conformité légale */}
      <div className="lg:col-span-1">
        <LegalCompliancePanel 
          selectedAG={selectedAG}
          token={token}
          onPublish={onUpdate}
          userRole={userRole}
        />
      </div>
    </div>
  );
};

export default AGInfoTab;
